<mat-card class="card">
  <card-header title="{{ 'SUBJECT_FOSTER_FAMILY.TITLE' | translate }}">
  </card-header
  >
  <ul class="family__list" *ngIf="members">
    <li *ngFor="let member of members" class="family__item">
      <app-foster-family-member
        [firstName]="member.firstName"
        [lastName]="member.lastName"
        [regId]="member.registrationId"
        [cpsuSubjectId]="member.cpsuSubId"
        [isFosterParent]="member.isFosterParent"
      ></app-foster-family-member>
    </li>
  </ul>
  <p class="family-empty" *ngIf="members.length === 0">
    <mat-icon class="family-empty__icon">info</mat-icon>
    {{ 'SUBJECT_FOSTER_FAMILY.NO_RESULTS' | translate }}
  </p>
</mat-card>
